// src/components/HeartRain.jsx
import React, { useEffect, useState } from "react";

export default function HeartRain() {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    const isMobile = window.innerWidth < 640;

    const spawn = setInterval(() => {
      const size = isMobile
        ? Math.floor(Math.random() * 10) + 10
        : Math.floor(Math.random() * 14) + 12;

      setHearts((prev) => {
        const newHeart = {
          id: Date.now(),
          left: Math.random() * window.innerWidth,
          size,
          duration: (Math.random() * 3 + 3).toFixed(2),
        };

        const updated = [...prev, newHeart];
        if (updated.length > (isMobile ? 6 : 12)) updated.shift();

        return updated;
      });
    }, isMobile ? 900 : 650);

    return () => clearInterval(spawn);
  }, []);

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        zIndex: 2,               /* ❤️ FIX: hearts visible above background */
        pointerEvents: "none",
      }}
    >
      {hearts.map((heart) => (
        <span
          key={heart.id}
          className="heart-rain"
          style={{
            left: heart.left,
            fontSize: heart.size,
            animationDuration: `${heart.duration}s`,
          }}
        >
          ❤️
        </span>
      ))}
    </div>
  );
}
